import axios from 'axios'

/**
 * @desc Fetch all Payment Day Rule for the specified supplier
 *
 * @param {Integer} supplierId
 */
export const fetchPaymentDayRules = (supplierId) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/payment-day-rules`)
    .then((res) => res.data)

/**
 * @desc Create a new Payment Day Rule for the specified supplier
 *
 * @param {Integer} supplierId
 * @param {Object} paymentDayRule
 */
export const createPaymentDayRule = (supplierId, paymentDayRule) =>
  axios
    .post(
      `/authenticated/supplier/${supplierId}/payment-day-rules`,
      paymentDayRule
    )
    .then((res) => res.data)

/**
 * @desc Update a Payment Day Rule for specified supplier
 *
 * @param {Integer} supplierId
 * @param {Integer} paymentDayRuleId
 * @param {Object} paymentDayRule
 */
export const updatePaymentDayRule = (
  supplierId,
  paymentDayRuleId,
  paymentDayRule
) =>
  axios
    .put(
      `/authenticated/supplier/${supplierId}/payment-day-rules/${paymentDayRuleId}`,
      paymentDayRule
    )
    .then((res) => res.data)

/**
 * @desc Delete Payment Day Rule for the specified supplier
 *
 * @param {Integer} supplierId
 * @param {Integer} paymentDayRuleId
 */
export const deletePaymentDayRule = (supplierId, paymentDayRuleId) =>
  axios
    .delete(
      `/authenticated/supplier/${supplierId}/payment-day-rules/${paymentDayRuleId}`
    )
    .then((res) => res.data)
